var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"row mx-0"},[_c('TheSidebar',{staticClass:"float-left mb-2"})],1),_c('router-view'),_c('label',{staticClass:"text-white"},[_vm._v(" © "+_vm._s(_vm.currentYear)+" Σώμα Ελλήνων Προσκόπων Πτολεμαίων 1, 11635, Αθήνα | Τηλ: 2107290046 | Φάξ: 2107236561 | hello@sep.org.gr")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }